
(function(){
  if (window.__lvScrollNavV177) return;
  window.__lvScrollNavV177 = true;

  var map = [
    { id: 'lv_hero', label: 'Keşfet' },
    { id: 'lv_showcase', label: 'Fark' },
    { id: 'lv_chaos_to_focus', label: 'Hikaye' },
    { id: 'lv_material', label: 'Materyal' },
    { id: 'product_list_bags', label: 'Ürünler' },
    { id: 'lv_faq', label: 'SSS' },
    { id: 'lv_waitlist', label: 'Waitlist' }
  ];

  function sectionEl(id){
    return document.getElementById('shopify-section-template--' + id) ||
           document.getElementById('shopify-section-' + id) ||
           document.querySelector('[id*="' + id + '"]');
  }

  function isVisible(el){
    if (!el) return false;
    if (el.closest('[hidden], .shopify-section-disabled')) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    return r.height > 40 && r.width > 40;
  }

  function headerHeight(){
    var h = document.getElementById('header-group') || document.querySelector('header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return Math.max(0, Math.round(r.height || 0));
  }

  function build(){
    var existing = document.querySelector('.lv-scroll-nav');
    if (existing) existing.remove();

    var targets = [];
    map.forEach(function(item){
      var el = sectionEl(item.id);
      if (isVisible(el)) targets.push({ el: el, label: item.label, id: item.id });
    });

    if (targets.length < 3) return;

    var nav = document.createElement('div');
    nav.className = 'lv-scroll-nav';
    nav.innerHTML =
      '<div class="lv-scroll-nav__line"><span class="lv-scroll-nav__fill"></span></div>' +
      '<div class="lv-scroll-nav__pills" aria-label="Sayfa bölümleri"></div>';

    var pills = nav.querySelector('.lv-scroll-nav__pills');

    targets.forEach(function(t, index){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lv-scroll-nav__pill';
      btn.textContent = t.label;
      btn.setAttribute('data-lv-anchor-index', index);
      btn.addEventListener('click', function(){
        var y = t.el.getBoundingClientRect().top + window.pageYOffset - headerHeight() - 8;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
      pills.appendChild(btn);
    });

    document.body.appendChild(nav);

    function update(){
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var progress = Math.min(1, Math.max(0, window.pageYOffset / max));
      document.documentElement.style.setProperty('--lv-page-progress', progress.toFixed(4));
      if (window.innerWidth >= 750) {
        document.body.classList.toggle('lv-progress-show', window.pageYOffset > Math.max(260, window.innerHeight * 0.45));
      } else {
        document.body.classList.add('lv-progress-show');
      }
      document.documentElement.style.setProperty('--lv-scroll-nav-top', '0px');

      var current = 0;
      var marker = window.innerHeight * 0.32;
      targets.forEach(function(t, i){
        var rect = t.el.getBoundingClientRect();
        if (rect.top - headerHeight() <= marker) current = i;
      });

      pills.querySelectorAll('.lv-scroll-nav__pill').forEach(function(btn, i){
        btn.classList.toggle('is-active', i === current);
      });

      var active = pills.querySelector('.is-active');
      if (active && window.innerWidth < 750) {
        var left = active.offsetLeft - (pills.clientWidth / 2) + (active.clientWidth / 2);
        pills.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }

    var ticking = false;
    function requestUpdate(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        update();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();

    setTimeout(function(){
      document.body.classList.add('lv-scroll-nav-ready');
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  document.addEventListener('shopify:section:load', function(){
    setTimeout(build, 250);
  });
})();
